import React, { useEffect, useState } from "react";

import * as api from "../api";
import AuditList from "../components/AuditList";
import type { PageProps } from "./types";

export default function Audit(_props: PageProps) {
  const [entries, setEntries] = useState<api.AuditEntry[] | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    api.listAudit().then(
      (r) => setEntries(r.entries),
      (e) => { setError(e?.message || "Audit unavailable"); setEntries([]); },
    );
  }, []);

  return (
    <div style={{ padding: "28px 32px 48px", maxWidth: 960 }}>
      <div style={{ background: "#fff", border: "1px solid var(--border-hairline)", borderRadius: 16, boxShadow: "var(--elevation-sm)", overflow: "hidden" }}>
        <div style={{ padding: "18px 22px", borderBottom: "1px solid var(--border-hairline)" }}>
          <h2 style={{ margin: 0, fontFamily: "var(--font-display)", fontWeight: 600, fontSize: 16, color: "var(--ink-900)" }}>Ops audit trail</h2>
          <p style={{ margin: "4px 0 0", fontSize: 12.5, color: "var(--text-muted)" }}>Every mutation, credit change and cross-org lookup, attributed to an operator.</p>
        </div>
        {error && <p style={{ padding: "12px 22px", color: "var(--danger-500)", fontSize: 13 }}>{error}</p>}
        {entries == null && !error ? (
          <div style={{ padding: 40, textAlign: "center", color: "var(--text-muted)", fontSize: 14 }}>Loading…</div>
        ) : (
          <div style={{ padding: entries && entries.length ? 0 : "20px 22px" }}>
            <AuditList entries={entries || []} emptyText="No audit entries yet." />
          </div>
        )}
      </div>
    </div>
  );
}
